export default {
    name: "qdList",
    data: function() {
        return {
            tab: '',
            list: [],
            showTips: false,
            Page: 1,
            Length: 10,
            total: 0,
            smStatus: 0,
            smMsg: ''
        }
    },
    methods: {
        checkCanApply: function() {
            var _this = this;

            this.$post("/customerservicemanager/queryisdeposit", function(res) {
                if (!res.Success) {
                    _this.smStatus = res.Result;
                    _this.smMsg = res.Message;
                } else {

                }
            })

        },
        getList: function() {
            var _this = this;
            this.$post("/servant/getlistjob", {
                JobType: this.tab,
                ServantId: this.$route.query.id || '',
                CityId: this.$getCity() || '',
                ProfileStoreId: this.$getProfileStoreId() || '',
                Page: this.Page,
                Length: this.Length
            }, function(res) {
                _this.list = _this.list.concat(res.ListJob);
                _this.total = Math.ceil(res.TotalCount / _this.Length);
                _this.Page++;
                if (res.ListJob.length == 0) {
                    _this.showTips = true;
                } else {
                    _this.showTips = false;
                }
            })
        },
        nextPage: function() {
            if (this.Page < this.total) {
                this.getList();
            }
        },
        recommend: function(job) { //id, jobTypeStr
            var self = this;
            if (!self.$isLogin()) {
                self.$toast("请先注册");
                setTimeout(() => {
                    dsBridge.call("login", "", function(session) {
                        window.sessionStorage.setItem("session", session);
                        self.getList();
                        self.checkCanApply();
                    });
                }, 2000);
                return;
            }

            if (self.smStatus === 1 || self.smStatus === 2 || self.smStatus === 3) {
                self.$toast(self.smMsg);
                if (self.smStatus === 1) {
                    self.$router.push({ name: 'payBalance' });
                }
                return;
            }

            //TODO remove
            var jobTypeObj = {
                "临时保洁": 1,
                "长期钟点工": 2,
                "全天保姆": 3,
                "住家保姆": 4,
                "月嫂": 5,
                "育婴师": 6,
                "催乳师": 7,
                "专业除螨": 8,
                "早出晚归": 9,
                "其他": 99
            };
            var jobType = jobTypeObj[job.JobTypeStr] || 1;
            window.sessionStorage.setItem("curr_job", JSON.stringify({
                JobId: job.JobId,
                JobTypeStr: job.JobTypeStr,
                SalaryRange: job.SalaryRange,
                SalaryRangeUnit: job.SalaryRangeUnit
            }));
            this.$router.push({ name: "serverList", query: { id: job.JobId, jobType: jobType, jobTypeStr: encodeURIComponent(job.JobTypeStr || "临时保洁") } });
        },
        checkTab: function(str) {
            this.tab = (this.tab == str ? '' : str);
            this.Page = 1;
            this.list = [];
            this.getList();
        },
        showJob: function(job) {
            var self = this;
            if (!self.$isLogin()) {
                self.$toast("请先登录");
                setTimeout(() => {
                    dsBridge.call("login", "", function(session) {
                        window.sessionStorage.setItem("session", session);
                        self.getList();
                    });
                }, 2000);
                return;
            }
            window.sessionStorage.setItem("curr_job", JSON.stringify({
                JobId: job.JobId,
                JobTypeStr: job.JobTypeStr,
                SalaryRange: job.SalaryRange,
                SalaryRangeUnit: job.SalaryRangeUnit
            }));
            this.$router.push({ name: "jobDetail", query: { id: job.JobId } })
        }
    },
    mounted: function() {
        this.getList();
        this.checkCanApply();
    }
}



// WEBPACK FOOTER //
// ./src/ally/page/home/qdList.js